import React from "react"
import Button from "@material-ui/core/Button"
import { IntlContextConsumer, changeLocale } from "gatsby-plugin-intl"

const languageName = {
  en: "English",
  es: "Español",
}

const Language = () => {
  return (
    <div>
      <IntlContextConsumer>
        
          {({ languages, language: currentLocale }) =>
            languages.map(language => (
              <Button
                size="small"
                variant="outlined"
                key={language}
                onClick={() => changeLocale(language)}
                style={{
                  color:
                    currentLocale === language
                      ? `var(--primaryColor)`
                      : `var(--secondaryColor)`,
                  fontSize: ".6rem",

                  cursor: `pointer`,
                }}
              >
                {languageName[language]}
              </Button>
            ))
          }
        
      </IntlContextConsumer>
    </div>
  )
}

export default Language
